import { render, staticRenderFns } from "./ResultsPerSellerTable.vue?vue&type=template&id=47d28f9f&"
import script from "./ResultsPerSellerTable.vue?vue&type=script&lang=js&"
export * from "./ResultsPerSellerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports